import React from 'react';
import { DollarSign } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { useApp } from '../context/AppContext';
import { CURRENCIES } from '../lib/utils';
import { useHeaderTheme } from './layout/HeaderThemeContext';

const CurrencySelector = ({ compact = false }) => {
  const { currency, setCurrency } = useApp();
  const { onDark } = useHeaderTheme();

  if (compact) {
    return (
      <Select value={currency} onValueChange={setCurrency}>
        <SelectTrigger
          className={`w-[90px] h-8 text-xs ${onDark ? 'text-slate-200 border-[#1f2a44] bg-transparent hover:bg-white/5' : ''}`}
          data-testid="currency-selector"
        >
          <SelectValue>
            <span className="flex items-center gap-1">
              <span className="font-medium">{CURRENCIES[currency]?.symbol}</span>
              <span className={onDark ? 'text-slate-400' : 'text-slate-500'}>{currency}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {Object.values(CURRENCIES).map((curr) => (
            <SelectItem key={curr.code} value={curr.code} className="text-xs">
              <span className="flex items-center gap-2">
                <span className="w-6 font-medium">{curr.symbol}</span>
                <span>{curr.code}</span>
                <span className="text-slate-400">- {curr.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <DollarSign className="h-4 w-4 text-slate-500" />
      <Select value={currency} onValueChange={setCurrency}>
        <SelectTrigger className="w-[180px]" data-testid="currency-selector">
          <SelectValue>
            <span className="flex items-center gap-2">
              <span className="font-medium">{CURRENCIES[currency]?.symbol}</span>
              <span>{CURRENCIES[currency]?.name}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {Object.values(CURRENCIES).map((curr) => (
            <SelectItem key={curr.code} value={curr.code}>
              <span className="flex items-center gap-2">
                <span className="w-8 font-medium">{curr.symbol}</span>
                <span>{curr.name}</span>
                <span className="text-slate-400 text-xs">({curr.code})</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CurrencySelector;
